var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"246","height":"170","viewBox":"0 0 246 170","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"246","height":"170","rx":"4","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }